export default __webpack_public_path__ + "static/every-drop-count-slider_bg-8eb7552b157037ff5d8adfda18f57851.png";